var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{staticClass:"py-0 mb-3",attrs:{"cols":12}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }